import angular from 'angular';
import routesConfiguration from './configuration.routes';
import popover from 'angular-ui-bootstrap/src/popover';

import {ListSchoolCommonRooms} from './list-school-common-rooms/list-school-common-rooms.component';
import {SchoolCommonRoomEmployees} from './school-common-room-employees/school-common-room-employees.component';

import AddSchoolCommonRoomController from './add-school-common-room/add-school-common-room.controller';
import EditSchoolCommonRoomController from './edit-school-common-room/edit-school-common-room.controller';

import './configuration.scss';

/**
 * @desc  Module initialize.
 *
 * @ngInject
 */
export default angular
  .module('app.modules.configuration', [
    popover
  ])
  .component('listSchoolCommonRoomsComponent', ListSchoolCommonRooms)
  .component('schoolCommonRoomEmployeesComponent', SchoolCommonRoomEmployees)
  .controller('AddSchoolCommonRoomController', AddSchoolCommonRoomController)
  .controller('EditSchoolCommonRoomController', EditSchoolCommonRoomController)
  .config(routesConfiguration)
  .name;
